import { useXR } from "@react-three/xr";
import { useStore, PRODUCTS, RING_VARIANTS } from "@/store/useStore";

function Tile({ position, color, active, onClick, size = [0.3, 0.3, 0.06] }) {
  return (
    <mesh
      position={position}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <boxGeometry args={size} />
      <meshStandardMaterial
        color={color}
        emissive={color}
        emissiveIntensity={active ? 1.0 : 0.25}
        metalness={0.25}
        roughness={0.45}
        toneMapped={false}
      />
    </mesh>
  );
}

/* In-headset 3D controls (controller-ray selectable) for the key actions that
   are otherwise DOM overlays unreachable inside an immersive session:
   product switching and ring variant/size. Renders only during an XR session. */
export default function HeadsetControls() {
  const session = useXR((s) => s.session);
  const product = useStore((s) => s.product);
  const setProduct = useStore((s) => s.setProduct);
  const variant = useStore((s) => s.variant);
  const setVariant = useStore((s) => s.setVariant);
  const ringSize = useStore((s) => s.ringSize);
  const setRingSize = useStore((s) => s.setRingSize);

  if (!session) return null;

  const productColors = { airpods: "#00f0ff", melasyl: "#a855f7", lotus: "#d4af37" };

  return (
    <group position={[-1.8, 0.2, 0.9]} rotation={[0, 0.55, 0]}>
      {/* backing panel */}
      <mesh position={[0, 0, -0.05]}>
        <boxGeometry args={[1.4, product === "lotus" ? 1.9 : 0.9, 0.03]} />
        <meshStandardMaterial color="#0a0e16" transparent opacity={0.72} />
      </mesh>

      {/* product switch row */}
      {Object.values(PRODUCTS).map((p, i) => (
        <Tile
          key={p.id}
          position={[(i - 1) * 0.42, 0.5, 0]}
          color={productColors[p.id]}
          active={product === p.id}
          onClick={() => setProduct(p.id)}
        />
      ))}

      {product === "lotus" && (
        <>
          {/* variant swatches */}
          {Object.entries(RING_VARIANTS).map(([id, v], i) => (
            <Tile
              key={id}
              position={[(i - 1) * 0.42, -0.1, 0]}
              color={v.swatch}
              active={variant === id}
              onClick={() => setVariant(id)}
            />
          ))}
          {/* size down / up */}
          <Tile position={[-0.28, -0.7, 0]} color="#38bdf8" size={[0.26, 0.26, 0.06]} onClick={() => setRingSize(Math.max(6, ringSize - 1))} />
          <Tile position={[0.28, -0.7, 0]} color="#38bdf8" size={[0.26, 0.26, 0.06]} onClick={() => setRingSize(Math.min(12, ringSize + 1))} />
        </>
      )}
    </group>
  );
}
